const key = "erp-login-identity-v1";
export interface LoginIdentity {
  tenantCode: string;
  username: string;
}
export function readLoginIdentity(
  storage: Pick<Storage, "getItem">,
): LoginIdentity | undefined {
  try {
    const value = JSON.parse(storage.getItem(key) ?? "null");
    if (
      value &&
      typeof value.tenantCode === "string" &&
      value.tenantCode.length <= 80 &&
      typeof value.username === "string" &&
      value.username.length <= 80
    )
      return { tenantCode: value.tenantCode, username: value.username };
  } catch {
    /* A damaged preference must not prevent login. */
  }
  return undefined;
}
export function saveLoginIdentity(
  storage: Pick<Storage, "setItem" | "removeItem">,
  remember: boolean,
  identity: LoginIdentity,
) {
  try {
    if (remember)
      storage.setItem(
        key,
        JSON.stringify({
          tenantCode: identity.tenantCode.trim(),
          username: identity.username.trim(),
        }),
      );
    else storage.removeItem(key);
  } catch {
    /* Login still works when browser storage is unavailable. */
  }
}
